import { CSSProperties, FC } from 'react'

import { cn } from '@/app/utils'
import { ButtonSkeleton, CardSkeleton } from '@/components/shared/skeleton'

type Props = {
  className?: string
  style?: CSSProperties
}

const CommentsSkeleton: FC<Props> = ({ className, style }) => {
  return (
    <div className={cn('flex flex-col', className)} style={style}>
      <div className="mr-[-7px] mt-20 flex min-h-0 flex-grow flex-col overflow-y-auto pr-8">
        <CardSkeleton className="!h-full min-h-0 !w-full flex-1" />
      </div>

      <div className="flex-shrink-0 pb-24">
        <div className="mb-24 pt-24">
          <CardSkeleton className="!h-[120px] !w-full rounded-12" />
        </div>
        <div className="relative flex items-center">
          <ButtonSkeleton className="!h-[56px] !w-[60px] rounded-12" />
          <ButtonSkeleton className="absolute bottom-0 right-0 !h-[56px] !w-full max-w-[calc(100%-70px)] rounded-12" />
        </div>
      </div>
    </div>
  )
}

export default CommentsSkeleton
